import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { AxiosRequestConfig } from "axios";

export interface Usuario {
  tokenUsuario: string;
  rutUsuario: string;
  rutUsuarioDv: string;
  codigoRol: string;
  rutProveedor: string;
  proveedorId: number;
  nombres: string;
  apellidos: string;
  email: string;
  telefono: string;
  clave: string;
  ultimaClave: string;
  debeCambiarClave: string;
  fechaCreacion: Date;
  fechaActualizacion: Date;
  activo: boolean;
}

export interface UsuarioInfo {
  errors: unknown;
  usuario: Usuario;
  usuarios: Array<Usuario>;
}

@Module
export default class UsuarioModule extends VuexModule implements UsuarioInfo {
  errors = {};
  usuario = {} as Usuario;
  usuarios = [] as Array<Usuario>;

  /**
   * Get current usuario object
   * @returns Usuario
   */
  get currentUsuario(): Usuario {
    return this.usuario;
  }

  /**
   * Get all usuarioes
   * @returns Array<Usuario>
   */
  get allUsuarios(): Array<Usuario> {
    return this.usuarios;
  }

  /**
   * Get errors
   * @returns array
   */
  get getUsuarioErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_USUARIO_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_USUARIO](usuario) {
    this.usuario = usuario;
  }

  @Mutation
  [Mutations.SET_USUARIOS](usuarios) {
    this.usuarios = usuarios;
  }

  @Action
  [Actions.GET_USUARIOS]() {
    return ApiService.get(`usuario/v1/usuarios`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIOS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_USUARIOS_ADMINISTRADORES]() {
    return ApiService.get(`usuario/v1/administradores`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIOS, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.GET_USUARIO](id) {
    return ApiService.get(`usuario/v1/usuario/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }
  @Action
  [Actions.INS_USUARIO](params) {
    return ApiService.post(`usuario/v1/usuario`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }
  @Action
  [Actions.INS_USUARIO_ADMINISTRADOR](params) {
    return ApiService.post(`usuario/v1/administrador`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }
  @Action
  [Actions.UPD_USUARIO](params) {
    return ApiService.put(`usuario/v1/usuario/${params.tokenUsuario}`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.UPD_USUARIO_DATOS_BASE](params) {
    params.telefono = parseInt(params.telefono)
    return ApiService.put(`usuario/v1/usuario/${params.tokenUsuario}`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.UPD_USUARIO_UP](params) {
    return ApiService.put(
      `usuario/v1/usuario/${params.tokenUsuario}/activar`,
      params
    ).catch(({ response }) => {
      this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
    });
  }
  @Action
  [Actions.UPD_USUARIO_DOWN](params) {
    return ApiService.put(
      `usuario/v1/usuario/${params.tokenUsuario}/desactivar`,
      params
    ).catch(({ response }) => {
      this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
    });
  }

  @Action
  [Actions.UPD_CONTRASENA_USUARIO](params) {
    return ApiService.put(
      `usuario/v1/usuario/${params.tokenUsuario}/contrasena`,
      params
    )
      .then()
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.UPD_RESETEO_CONTRASENA_USUARIO](params) {
    return ApiService.put(
      `usuario/v1/usuario/${params.tokenUsuario}/resetearContrasena`,
      params
    )
      .then()
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.DEL_USUARIO](params) {
    return ApiService.delete(`usuario/v1/usuario/${params.tokenUsuario}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_USUARIO, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_USUARIO_ERROR, response.data.errors);
      });
  }
}
